import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import * as RoomActionType from '../../Rooms/constants';
import * as WorkOrderActionType from '../../Work-Orders/constants';
import { AppSettings } from '../../constants';
import shallowEqual from 'recompose/shallowEqual';
import * as LotActionType from '.../../Lots/constants';
let isDisabled = true;
let originalState = null;
class HomeownerEditWorkOrder extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    LotStore: PropTypes.any,
    homeownerRoomSelectList: PropTypes.array,
    onCancelClick: PropTypes.func,
    WORefNo: PropTypes.any,
    WorkOrderProfile: PropTypes.object
  }

  constructor(props) {

    super(props);
    this.woInformation = props.WorkOrderProfile && props.WorkOrderProfile.workOrder && props.WorkOrderProfile.workOrder.woInformation ? props.WorkOrderProfile.workOrder.woInformation : {} ;
    this.state = {
      files: [],
      error: null,
      lotDetail: {},
      room: this.woInformation.room ? {
        value: this.woInformation.room.id,
        text: this.woInformation.room.name,
        extensionValue: null,
        selected: false
      } : null,
      title: this.woInformation.title,
      description: this.woInformation.description
    };
    originalState = this.state;
    isDisabled = true;
  }

  componentDidMount() {
    const {WorkOrderProfile: {requestDetail}} = this.props;
    if (!this.props.LotStore.HomeownerLots.length) {
      this.props.dispatch({
        type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
        params: {lotId: requestDetail.lot.id},
        callbackSetLotDetail: (lotDetail) => {this.setLotDetail(lotDetail);}
      });
    } else {
      const lotFound = this.props.LotStore.HomeownerLots.find(item => item.lot.id === requestDetail.lot.id);
      this.setLotDetail(lotFound);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState && originalState) {
      const checkStateChanged = (
        !shallowEqual(nextState.room, originalState.room) ||
        (nextState.title !== originalState.title) ||
        (nextState.description !== originalState.description)
      );
      if (checkStateChanged) {
        isDisabled = false;
      } else {
        isDisabled = true;
      }
    }
  }

  setLotDetail = (lotDetail) => {
    this.setState({lotDetail});
  }

  handleCancel = () => {
    this.props.onCancelClick();
  }

  checkRequiredField = () => {
    const { room, title} = this.state;
    let isMatch = false;
    isMatch = room && (title !== '');
    return isMatch;
  }

  fetchRoomSelectList = () => {
    const {builderProfile} = this.state.lotDetail;
    const {WorkOrderProfile: {requestDetail}} = this.props;
    this.setState({isLoadingRoomSelectList: true}, () => {
      this.props.dispatch({
        type: RoomActionType.FETCH_HOMEOWNER_ROOM_SELECT_LIST_ASYNC,
        params: {
          lotId: requestDetail.lot.id,
          endpoint: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        },
        callback: () => {this.setState({isLoadingRoomSelectList: false});}
      });
    });
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
  }

  addHomeownerWorkOrderCallback = () => {
    this.props.onCancelClick();
  }

  onSubmit = (e) => {
    e.preventDefault();
    const {lotDetail, room } = this.state;
    const {WorkOrderProfile: {workOrder}} = this.props;
    let { title, description } = this.form.getValues();
    // console.log(data, 'in the submit');
    const params = {
      title: title,
      description,
      roomId: room.value
    };
    // data.roomId = location ? location.value : workOrder.woInformation.room.id;
    this.props.dispatch({
      type: WorkOrderActionType.EDIT_HOMEOWNER_WORK_ORDER_ASYNC,
      params: {
        data: params,
        refNo: workOrder.woInformation.refNo,
        endpoint: lotDetail.builderProfile.builderHost,
        headers: {
          key: lotDetail.builderProfile.headerKey,
          value: lotDetail.builderProfile.securityToken
        }
      },
      callback: this.addHomeownerWorkOrderCallback
    });
  }

  render() {
    const { woInformation } = this.props.WorkOrderProfile.workOrder;
    const checkIsMatch = this.checkRequiredField();
    let { title, description } = woInformation;
    if (this.form) {
      title = this.form.getValues().title ? this.form.getValues(true).title : title ;
      description = this.form.getValues().description ? this.form.getValues(true).description : description ;
    }
    return (
      <div>
        <Form className='form-horizontal' ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>

          {/*<div className='row col-sm-12'>
            <div className='col-sm-6'>
              <p style={{color: 'rgb(117, 117, 117)'}}>Problem #1</p>
            </div>
          </div>*/}

          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{paddingLeft: 0}}>
              <label className='col-sm-3' style={{ fontWeight: 500 }}>Status</label>
              <div className='col-sm-9'>
                <span style={{ fontWeight: 600 }}>{AppSettings.WO_STATUS_VALUE.find(x => x.key === woInformation.status).value}</span>
                {/* 3 === declined*/}
                {woInformation.status === 3 && woInformation.declinedReason &&
                <span
                  className='text-danger'
                  style={{fontSize: 14, display: 'block'}}>
                  Reason: "{woInformation.declinedReason}"
                </span>
                }
              </div>
            </div>
          </div>

          {/* <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{paddingLeft: 0}}>
              <label className='col-sm-12 control-label form-siteone-label'>Location <span className='text-danger'>*</span></label>
              <div className='col-sm-12'>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'location'); }}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchRoomSelectList} // eslint-disable-next-line
                  options={!isEmpty(this.props.homeownerRoomSelectList) ? this.props.homeownerRoomSelectList : [{value: woInformation.room.id, text: woInformation.room.name, selected: false}]}
                  optionLabel='text'
                  loading={this.state.isLoadingRoomSelectList}
                  value={this.state.location ? this.state.location : {value: woInformation.room.id, text: woInformation.room.name }}
                  showClear={false}
                  name='location'
                  placeholder='--Please select'
                  style={{ width: '100%', paddingLeft: 15 }} />
              </div>
            </div>
          </div> */}

          <div className='row col-lg-12 col-sm-12'>
            <div className='col-sm-6' style={{padding: 0}}>
              <label className='col-sm-12 control-label form-siteone-label'>Location <span className='text-danger'>*</span></label>
              <div className='col-sm-12'>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'room'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchRoomSelectList}
                  options={!isEmpty(this.props.homeownerRoomSelectList) ? this.props.homeownerRoomSelectList : [{value: woInformation.room.id, text: woInformation.room.name, selected: false}]}
                  optionLabel='text'
                  value={this.state.room}
                  loading={this.state.isLoadingRoomSelectList}
                  showClear={true}
                  placeholder='--Please select'
                  style={{ width: '100%', paddingLeft: 15 }} />
              </div>
            </div>
          </div>

          <div className='row col-sm-12 form-group'>
            <label className='col-sm-12 control-label form-siteone-label'>Summary<span className='text-danger'> *</span>
            </label>
            <div className='col-sm-12' style={{padding: '0 15px'}}>
              <Input
                type='text'
                name='title'
                ref='title'
                className='form-control'
                max='200'
                maxLength='200'
                // onBlur={() => this.setState({title: this.form.getValues(true).title})}
                onChangeCallback={(value) => { this.setState({ title: value }); }}
                value={this.state.title}
                errorMsg='Summary is maximum 200 characters'
                validations={[Vali.required, Vali.maxlength]} />
            </div>
          </div>

          <div className='row col-sm-12 form-group'>
            <label className='col-sm-12 control-label form-siteone-label'>Description</label>
            <div className='col-sm-12' style={{padding: '0 15px'}}>
              <Textarea
                className='form-control'
                name='description'
                ref='description'
                max='1000'
                maxLength='1000'
                // onBlur={() => this.setState({description: this.form.getValues(true).description})}
                onChangeCallback={(value) => { this.setState({ description: value }); }}
                value={this.state.description}
                errorMsg='Description is maximum 1000 characters'
                style={{height: 130}}
                validations={[Vali.maxlength]} />
            </div>
          </div>

          <ul className='wo-detail-bottom-btn'>
            <li>
              <span className='btn btn-primary btn-siteone-default' onClick={this.handleCancel}>Cancel</span>
            </li>
            <li><Submit disabled={isDisabled || !checkIsMatch} className='btn btn-primary btn-submit btn-siteone'>Save</Submit></li>
          </ul>

        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotStore: state.LotStore,
    HomeownerLots: state.LotStore.HomeownerLots,
    homeownerRequestTypeList: state.RequestTypeStore.homeownerRequestTypeList,
    homeownerRoomSelectList: state.RoomStore.homeownerRoomSelectList,
    Credentials: state.WorkOrderReducer.Credentials
  };
};

export default connect(mapStateToProps)(HomeownerEditWorkOrder);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/HomeownerEditWorkOrder.js